import { render } from "./ContactInfoCard.vue?vue&type=template&id=da8f36e0&ts=true"
import script from "./ContactInfoCard.ts?vue&type=script&lang=ts&external"
export * from "./ContactInfoCard.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__